/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteV2EmployeesBatch200Item,
  DeleteV2EmployeesBatchBodyItem,
  DeleteV2EmployeesBatchParams,
  GetV2Employees200Item,
  GetV2EmployeesParams,
  HandlersPutEmployeesBatchItem,
  PostV2EmployeesInvite200,
  PostV2EmployeesInviteBody,
  PostV2EmployeesResendInvite200,
  PostV2EmployeesResendInviteBody,
  PutV2Employees200Item,
  PutV2EmployeesBatch200Item,
  PutV2EmployeesBody,
  PutV2EmployeesParams
} from '../../model';

import { webplatformProxyInstance } from '../../../../../lib/integrations/axios.ts';
import type { ErrorType } from '../../../../../lib/integrations/axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * This endpoint will return a list of employees based on the filter provided
 * @summary An endpoint to request many employees details
 */
export const getV2Employees = (
    params?: GetV2EmployeesParams,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV2Employees200Item[]>(
      {url: `/v2/employees`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetV2EmployeesQueryKey = (params?: GetV2EmployeesParams,) => {
    return [
    `/v2/employees`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetV2EmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getV2Employees>>, TError = ErrorType<unknown>>(params?: GetV2EmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Employees>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2EmployeesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2Employees>>> = ({ signal }) => getV2Employees(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2Employees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2EmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getV2Employees>>>
export type GetV2EmployeesQueryError = ErrorType<unknown>


export function useGetV2Employees<TData = Awaited<ReturnType<typeof getV2Employees>>, TError = ErrorType<unknown>>(
 params: undefined |  GetV2EmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Employees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2Employees>>,
          TError,
          Awaited<ReturnType<typeof getV2Employees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2Employees<TData = Awaited<ReturnType<typeof getV2Employees>>, TError = ErrorType<unknown>>(
 params?: GetV2EmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Employees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2Employees>>,
          TError,
          Awaited<ReturnType<typeof getV2Employees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2Employees<TData = Awaited<ReturnType<typeof getV2Employees>>, TError = ErrorType<unknown>>(
 params?: GetV2EmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Employees>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary An endpoint to request many employees details
 */

export function useGetV2Employees<TData = Awaited<ReturnType<typeof getV2Employees>>, TError = ErrorType<unknown>>(
 params?: GetV2EmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Employees>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2EmployeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * This endpoint will update many employees based on the filter provided
 * @summary An endpoint to update many employees with a filter query
 */
export const putV2Employees = (
    putV2EmployeesBody: PutV2EmployeesBody,
    params?: PutV2EmployeesParams,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<PutV2Employees200Item[]>(
      {url: `/v2/employees`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV2EmployeesBody,
        params, signal
    },
      options);
    }




export const getPutV2EmployeesMutationKey = () => ['putV2Employees'] as const;

export const getPutV2EmployeesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2Employees>>, TError,PutV2EmployeesMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putV2Employees>>, TError,PutV2EmployeesMutationVariables, TContext> => {

const mutationKey = getPutV2EmployeesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV2Employees>>, PutV2EmployeesMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  putV2Employees(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV2EmployeesMutationResult = NonNullable<Awaited<ReturnType<typeof putV2Employees>>>
    export type PutV2EmployeesMutationBody = PutV2EmployeesBody
    export type PutV2EmployeesMutationError = ErrorType<unknown>
    export type PutV2EmployeesMutationVariables = {data: PutV2EmployeesBody;params?: PutV2EmployeesParams}

    /**
 * @summary An endpoint to update many employees with a filter query
 */
export const usePutV2Employees = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2Employees>>, TError,PutV2EmployeesMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV2Employees>>,
        TError,
        PutV2EmployeesMutationVariables,
        TContext
      > => {
      return useMutation(getPutV2EmployeesMutationOptions(options), queryClient);
    }
    /**
 * This endpoint will update many employees based on the primary key provided
 * @summary An endpoint to update many employees in a batch
 */
export const putV2EmployeesBatch = (
    handlersPutEmployeesBatchItem: HandlersPutEmployeesBatchItem[],
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<PutV2EmployeesBatch200Item[]>(
      {url: `/v2/employees/batch`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlersPutEmployeesBatchItem, signal
    },
      options);
    }




export const getPutV2EmployeesBatchMutationKey = () => ['putV2EmployeesBatch'] as const;

export const getPutV2EmployeesBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2EmployeesBatch>>, TError,PutV2EmployeesBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putV2EmployeesBatch>>, TError,PutV2EmployeesBatchMutationVariables, TContext> => {

const mutationKey = getPutV2EmployeesBatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV2EmployeesBatch>>, PutV2EmployeesBatchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putV2EmployeesBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV2EmployeesBatchMutationResult = NonNullable<Awaited<ReturnType<typeof putV2EmployeesBatch>>>
    export type PutV2EmployeesBatchMutationBody = HandlersPutEmployeesBatchItem[]
    export type PutV2EmployeesBatchMutationError = ErrorType<unknown>
    export type PutV2EmployeesBatchMutationVariables = {data: HandlersPutEmployeesBatchItem[]}

    /**
 * @summary An endpoint to update many employees in a batch
 */
export const usePutV2EmployeesBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2EmployeesBatch>>, TError,PutV2EmployeesBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV2EmployeesBatch>>,
        TError,
        PutV2EmployeesBatchMutationVariables,
        TContext
      > => {
      return useMutation(getPutV2EmployeesBatchMutationOptions(options), queryClient);
    }
    /**
 * This endpoint will delete many employees based on the primary key provided
 * @summary An endpoint to delete many employees in a batch
 */
export const deleteV2EmployeesBatch = (
    deleteV2EmployeesBatchBodyItem: DeleteV2EmployeesBatchBodyItem[],
    params?: DeleteV2EmployeesBatchParams,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<DeleteV2EmployeesBatch200Item[]>(
      {url: `/v2/employees/batch`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteV2EmployeesBatchBodyItem,
        params, signal
    },
      options);
    }




export const getDeleteV2EmployeesBatchMutationKey = () => ['deleteV2EmployeesBatch'] as const;

export const getDeleteV2EmployeesBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteV2EmployeesBatch>>, TError,DeleteV2EmployeesBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteV2EmployeesBatch>>, TError,DeleteV2EmployeesBatchMutationVariables, TContext> => {

const mutationKey = getDeleteV2EmployeesBatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteV2EmployeesBatch>>, DeleteV2EmployeesBatchMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  deleteV2EmployeesBatch(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteV2EmployeesBatchMutationResult = NonNullable<Awaited<ReturnType<typeof deleteV2EmployeesBatch>>>
    export type DeleteV2EmployeesBatchMutationBody = DeleteV2EmployeesBatchBodyItem[]
    export type DeleteV2EmployeesBatchMutationError = ErrorType<unknown>
    export type DeleteV2EmployeesBatchMutationVariables = {data: DeleteV2EmployeesBatchBodyItem[];params?: DeleteV2EmployeesBatchParams}

    /**
 * @summary An endpoint to delete many employees in a batch
 */
export const useDeleteV2EmployeesBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteV2EmployeesBatch>>, TError,DeleteV2EmployeesBatchMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteV2EmployeesBatch>>,
        TError,
        DeleteV2EmployeesBatchMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteV2EmployeesBatchMutationOptions(options), queryClient);
    }
    /**
 * Creates an employee record with 'invited' status when a user is invited via Descope
 * @summary Create an employee record for an invited user
 */
export const postV2EmployeesInvite = (
    postV2EmployeesInviteBody: PostV2EmployeesInviteBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<PostV2EmployeesInvite200>(
      {url: `/v2/employees/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postV2EmployeesInviteBody, signal
    },
      options);
    }




export const getPostV2EmployeesInviteMutationKey = () => ['postV2EmployeesInvite'] as const;

export const getPostV2EmployeesInviteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV2EmployeesInvite>>, TError,PostV2EmployeesInviteMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postV2EmployeesInvite>>, TError,PostV2EmployeesInviteMutationVariables, TContext> => {

const mutationKey = getPostV2EmployeesInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV2EmployeesInvite>>, PostV2EmployeesInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postV2EmployeesInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV2EmployeesInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postV2EmployeesInvite>>>
    export type PostV2EmployeesInviteMutationBody = PostV2EmployeesInviteBody
    export type PostV2EmployeesInviteMutationError = ErrorType<unknown>
    export type PostV2EmployeesInviteMutationVariables = {data: PostV2EmployeesInviteBody}

    /**
 * @summary Create an employee record for an invited user
 */
export const usePostV2EmployeesInvite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV2EmployeesInvite>>, TError,PostV2EmployeesInviteMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV2EmployeesInvite>>,
        TError,
        PostV2EmployeesInviteMutationVariables,
        TContext
      > => {
      return useMutation(getPostV2EmployeesInviteMutationOptions(options), queryClient);
    }
    /**
 * Re-sends the Descope invite for a pending employee without changing their role
 * @summary Resend a pending invite
 */
export const postV2EmployeesResendInvite = (
    postV2EmployeesResendInviteBody: PostV2EmployeesResendInviteBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<PostV2EmployeesResendInvite200>(
      {url: `/v2/employees/resend-invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postV2EmployeesResendInviteBody, signal
    },
      options);
    }




export const getPostV2EmployeesResendInviteMutationKey = () => ['postV2EmployeesResendInvite'] as const;

export const getPostV2EmployeesResendInviteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV2EmployeesResendInvite>>, TError,PostV2EmployeesResendInviteMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postV2EmployeesResendInvite>>, TError,PostV2EmployeesResendInviteMutationVariables, TContext> => {

const mutationKey = getPostV2EmployeesResendInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV2EmployeesResendInvite>>, PostV2EmployeesResendInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postV2EmployeesResendInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV2EmployeesResendInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postV2EmployeesResendInvite>>>
    export type PostV2EmployeesResendInviteMutationBody = PostV2EmployeesResendInviteBody
    export type PostV2EmployeesResendInviteMutationError = ErrorType<unknown>
    export type PostV2EmployeesResendInviteMutationVariables = {data: PostV2EmployeesResendInviteBody}

    /**
 * @summary Resend a pending invite
 */
export const usePostV2EmployeesResendInvite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV2EmployeesResendInvite>>, TError,PostV2EmployeesResendInviteMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV2EmployeesResendInvite>>,
        TError,
        PostV2EmployeesResendInviteMutationVariables,
        TContext
      > => {
      return useMutation(getPostV2EmployeesResendInviteMutationOptions(options), queryClient);
    }
